import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';





import StatusManagementPanel from './components/StatusManagementPanel';
import MessagingSection from './components/MessagingSection';

import ActionButtons from './components/ActionButtons';
import PhotoUploadSection from './components/PhotoUploadSection';
import PackagePhotoSection from '../shipment-tracking-timeline/components/PackagePhotoSection';
import DocumentUploadSection from './components/DocumentUploadSection';
import ShipmentItemsSection from './components/ShipmentItemsSection';
import PaymentTrackingSection from './components/PaymentTrackingSection';



import LoyaltyManagementSection from './components/LoyaltyManagementSection';
import { adminService } from '../../services/adminService';
import { supabase } from '../../lib/supabase';
import { invoiceService } from '../../services/invoiceService';
import { containerService } from '../../services/containerService';
import AdminNavigation from '../../components/ui/AdminNavigation';
import { pickupTaskService } from '../../services/pickupTaskService';
import RecipientFormSection from '../../components/RecipientFormSection';
import { trackShipmentEvent, trackError } from '../../services/analyticsService';


export default function ShipmentDetailManagement() {
  const { shipmentId } = useParams();
  const navigate = useNavigate();

  const [shipment, setShipment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [events, setEvents] = useState([]);
  const [messages, setMessages] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);

  // Documents & Factures
  const [shipmentFiles, setShipmentFiles] = useState([]);
  const [shipmentFilesLoading, setShipmentFilesLoading] = useState(false);

  // Edit/Delete state for Documents & Factures
  const [editingFile, setEditingFile] = useState(null);
  const [editFileName, setEditFileName] = useState('');
  const [editFileSaving, setEditFileSaving] = useState(false);

  // ✅ NEW: Add state for pickup photos with signed URLs
  const [pickupPhotosSignedUrls, setPickupPhotosSignedUrls] = useState([]);
  const [pickupPhotosLoading, setPickupPhotosLoading] = useState(false);
  const [pickupPhotosError, setPickupPhotosError] = useState('');

  // Add container-related state
  const [containers, setContainers] = useState([]);
  const [currentContainer, setCurrentContainer] = useState(null);
  const [selectedNewContainerId, setSelectedNewContainerId] = useState('');
  const [showContainerSelector, setShowContainerSelector] = useState(false);
  const [updating, setUpdating] = useState(false);

  // ✅ NEW: Add state for recipient editing with Abidjan fields
  const [isEditingReceiver, setIsEditingReceiver] = useState(false);
  const [receiverEdits, setReceiverEdits] = useState({
    name: '',
    phone: '',
    address: '',
    city: '',
    country: '',
    commune: '',
    neighborhood: '',
    address_complement: ''
  });

  // ✅ NEW: Add state for pickup task data (for signature URL)
  const [pickupTask, setPickupTask] = useState(null);
  const [downloadingEvidence, setDownloadingEvidence] = useState(false);

  useEffect(() => {
    if (shipmentId) {
      console.log('✅ Chargement envoi avec ID extrait des params:', shipmentId);
      trackShipmentEvent('viewed_admin', { id: shipmentId });
      loadShipmentDetails();
    }
  }, [shipmentId]);

  // ✅ NEW: Function to generate signed URLs for pickup photos
  const generatePickupPhotosSignedUrls = async (pickupPhotoUrls) => {
    if (!pickupPhotoUrls || pickupPhotoUrls?.length === 0) {
      setPickupPhotosSignedUrls([]);
      return;
    }
    
    try {
      setPickupPhotosLoading(true);
      setPickupPhotosError('');
      
      const signedUrls = [];
      
      for (const photoValue of pickupPhotoUrls) {
        if (!photoValue) continue;
        
        let filePath = '';
        
        // Case 1: Already a filePath (new format: "pickup-photos/xxx.jpg")
        if (photoValue?.startsWith('pickup-photos/')) {
          filePath = photoValue;
        }
        // Case 2: Full URL (old format: extract path)
        else if (photoValue?.includes('/storage/v1/object/public/shipment-photos/')) {
          const urlParts = photoValue?.split('/storage/v1/object/public/shipment-photos/');
          if (urlParts?.length >= 2) {
            filePath = urlParts?.[1];
          }
        }
        
        if (!filePath) continue;
        
        // Generate signed URL (valid for 1 hour)
        const { data: signedData, error: signedError } = await supabase
          ?.storage
          ?.from('shipment-photos')
          ?.createSignedUrl(filePath, 3600);
        
        if (!signedError && signedData?.signedUrl) {
          signedUrls?.push(signedData?.signedUrl);
        }
      }
      
      setPickupPhotosSignedUrls(signedUrls);
      
    } catch (error) {
      console.error('❌ Error generating pickup photos signed URLs:', error);
      setPickupPhotosError('Erreur lors du chargement des photos de collecte');
    } finally {
      setPickupPhotosLoading(false);
    }
  };

  // ✅ NEW: Load pickup task data for this shipment
  const loadPickupTaskForShipment = async (shipmentId) => {
    try {
      // Fetch pickup tasks for this shipment
      const tasks = await pickupTaskService?.getAll({ shipmentId });
      if (tasks && tasks?.length > 0) {
        // Take the most recent completed task
        const completedTask = tasks?.find(t => t?.status === 'termine');
        if (completedTask) {
          setPickupTask(completedTask);
          console.log('✅ Pickup task loaded:', completedTask);
        }
      }
    } catch (err) {
      console.error('❌ Error loading pickup task:', err);
    }
  };

  // ✅ NEW: Download evidence function with options
  const handleDownloadEvidence = async (downloadType) => {
    try {
      setDownloadingEvidence(true);
      
      const ref = shipment?.reference || shipment?.id;
      const signatureUrl = pickupTask?.clientSignatureUrl;
      const photoUrls = pickupPhotosSignedUrls || [];
      
      if (downloadType === 'separate') {
        // Download separately - create individual download links
        const downloads = [];
        
        // Add signature if available
        if (signatureUrl) {
          downloads?.push({
            url: signatureUrl,
            filename: `ADT-${ref}-signature.png`
          });
        }
        
        // Add photos
        photoUrls?.forEach((url, index) => {
          downloads?.push({
            url: url,
            filename: `ADT-${ref}-photo-${index + 1}.jpg`
          });
        });
        
        // Create download links for each file
        for (const download of downloads) {
          const response = await fetch(download?.url);
          const blob = await response?.blob();
          const downloadUrl = window.URL?.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = download?.filename;
          document.body?.appendChild(link);
          link?.click();
          document.body?.removeChild(link);
          window.URL?.revokeObjectURL(downloadUrl);
          
          // Small delay between downloads to prevent browser blocking
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        alert('✓ Téléchargement des preuves terminé');
        
      } else if (downloadType === 'zip') {
        // Import JSZip dynamically
        const JSZip = (await import('jszip'))?.default;
        const zip = new JSZip();
        
        // Add signature to ZIP if available
        if (signatureUrl) {
          const signatureResponse = await fetch(signatureUrl);
          const signatureBlob = await signatureResponse?.blob();
          zip?.file(`ADT-${ref}-signature.png`, signatureBlob);
        }
        
        // Add photos to ZIP
        for (let i = 0; i < photoUrls?.length; i++) {
          const photoResponse = await fetch(photoUrls?.[i]);
          const photoBlob = await photoResponse?.blob();
          zip?.file(`ADT-${ref}-photo-${i + 1}.jpg`, photoBlob);
        }
        
        // Generate ZIP and download
        const zipBlob = await zip?.generateAsync({ type: 'blob' });
        const zipUrl = window.URL?.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = `ADT-${ref}-preuves-collecte.zip`;
        document.body?.appendChild(link);
        link?.click();
        document.body?.removeChild(link);
        window.URL?.revokeObjectURL(zipUrl);
        
        alert('✓ Archive ZIP téléchargée avec succès');
      }
      
    } catch (err) {
      console.error('❌ Error downloading evidence:', err);
      alert('Erreur lors du téléchargement des preuves: ' + err?.message);
    } finally {
      setDownloadingEvidence(false);
    }
  };

  const loadShipmentDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔍 Appel service avec shipmentId:', shipmentId);
      const data = await adminService?.getShipmentWithItems(shipmentId);
      setShipment(data);

      // ✅ NEW: Generate signed URLs for pickup photos if they exist
      if (data?.pickup_photo_urls && data?.pickup_photo_urls?.length > 0) {
        await generatePickupPhotosSignedUrls(data?.pickup_photo_urls);
      }
      
      // ✅ NEW: Fetch pickup task data to get signature URL
      if (data?.id) {
        await loadPickupTaskForShipment(data?.id);
      }

      // ✅ FIXED: Initialize receiver edits with correct field mapping from database
      if (data) {
        setReceiverEdits({
          name: data?.receiver_name || '',
          phone: data?.receiver_phone || '',
          address: data?.receiver_address || '',
          city: data?.receiver_city || '',
          country: data?.receiver_country || '',
          commune: data?.receiver_commune || '',
          neighborhood: data?.receiver_neighborhood || '',
          address_complement: data?.receiver_address_complement || ''
        });
      }

      // ✅ NEW: Load messages for this shipment
      const messagesData = await adminService?.getShipmentMessages(shipmentId);
      setMessages(messagesData);

      // Load shipment files
      await loadShipmentFiles(shipmentId);
      
    } catch (err) {
      console.error('❌ Error loading shipment:', err);
      setError(err?.message || 'Erreur lors du chargement de l\'envoi');
    } finally {
      setLoading(false);
    }
  };

  const loadShipmentFiles = async (sid) => {
    const id = sid || shipmentId;
    if (!id) return;
    try {
      setShipmentFilesLoading(true);
      const { data, error } = await supabase
        ?.from('shipment_files')
        ?.select('*')
        ?.eq('shipment_id', id)
        ?.order('created_at', { ascending: false });
      if (error) throw error;
      setShipmentFiles(data || []);
    } catch (err) {
      console.error('❌ Erreur chargement fichiers envoi:', err);
      setShipmentFiles([]);
    } finally {
      setShipmentFilesLoading(false);
    }
  };

  const handleDeleteShipmentFile = async (file) => {
    if (!confirm(`Êtes-vous sûr de vouloir supprimer "${file?.file_name}" ?`)) return;
    try {
      // Try to delete from storage
      if (file?.file_url && file?.bucket_name) {
        await supabase?.storage?.from(file?.bucket_name)?.remove([file?.file_url]);
      }
      const { error } = await supabase?.from('shipment_files')?.delete()?.eq('id', file?.id);
      if (error) throw error;
      await loadShipmentFiles(shipmentId);
    } catch (err) {
      console.error('❌ Erreur suppression document:', err);
      alert('Erreur lors de la suppression: ' + err?.message);
    }
  };

  const openEditFileModal = (file) => {
    setEditingFile(file);
    setEditFileName(file?.file_name || '');
  };

  const closeEditFileModal = () => {
    setEditingFile(null);
    setEditFileName('');
  };

  const handleEditShipmentFileSave = async () => {
    if (!editingFile) return;
    if (!editFileName?.trim()) {
      alert('Le nom du document ne peut pas être vide.');
      return;
    }
    try {
      setEditFileSaving(true);
      const { error } = await supabase
        ?.from('shipment_files')
        ?.update({ file_name: editFileName?.trim() })
        ?.eq('id', editingFile?.id);
      if (error) throw error;
      closeEditFileModal();
      await loadShipmentFiles(shipmentId);
    } catch (err) {
      console.error('❌ Erreur modification document:', err);
      alert('Erreur lors de la modification: ' + err?.message);
    } finally {
      setEditFileSaving(false);
    }
  };

  const loadShipmentData = async () => {
    await loadShipmentDetails();
  };

  const handleLogout = () => {
    navigate('/login');
  };

  const handleBack = () => {
    navigate('/admin-shipments-dashboard');
  };

  const handleSenderChange = (field, value) => {
    setShipment(prev => ({
      ...prev,
      sender: { ...prev?.sender, [field]: value }
    }));
    setHasChanges(true);
  };

  const handleReceiverChange = (field, value) => {
    setShipment(prev => ({
      ...prev,
      receiver: { ...prev?.receiver, [field]: value }
    }));
    setHasChanges(true);
  };

  const handleShipmentDetailsChange = (field, value) => {
    setShipment(prev => ({ ...prev, [field]: value }));
    setHasChanges(true);
  };

  const handleReceiverFieldChange = (field, value) => {
    setReceiverEdits(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSaveReceiverChanges = async () => {
    if (!shipmentId) {
      alert('Aucun envoi à sauvegarder');
      return;
    }

    // Validation : seuls Nom et Téléphone sont obligatoires
    const validationErrors = {};
    if (!receiverEdits?.name?.trim()) {
      validationErrors.name = 'Le nom complet est obligatoire';
    }
    if (!receiverEdits?.phone?.trim()) {
      validationErrors.phone = 'Le téléphone est obligatoire';
    }
    if (Object.keys(validationErrors)?.length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    try {
      setActionLoading(true);
      console.log('💾 Sauvegarde modifications destinataire:', receiverEdits);
      
      const updateData = {
        receiver_name: receiverEdits?.name,
        receiver_phone: receiverEdits?.phone,
        receiver_address: receiverEdits?.address || null,
        receiver_city: receiverEdits?.city || null,
        receiver_country: "Côte d\'Ivoire", // Toujours Côte d'Ivoire — automatique
        receiver_commune: receiverEdits?.commune || null,
        receiver_neighborhood: receiverEdits?.neighborhood === '__autre__' ? null : (receiverEdits?.neighborhood || null),
        receiver_address_complement: receiverEdits?.address_complement || null,
        updated_at: new Date()?.toISOString()
      };

      const { data, error } = await supabase
        ?.from('shipments')
        ?.update(updateData)
        ?.eq('id', shipmentId)
        ?.select()
        ?.single();

      if (error) throw error;

      console.log('✅ Destinataire mis à jour:', data);
      
      // ✅ Update local state immediately to avoid blank fields during reload
      setShipment(prev => ({
        ...prev,
        receiver_name: data?.receiver_name,
        receiver_phone: data?.receiver_phone,
        receiver_address: data?.receiver_address,
        receiver_city: data?.receiver_city,
        receiver_country: data?.receiver_country,
        receiver_commune: data?.receiver_commune,
        receiver_neighborhood: data?.receiver_neighborhood,
        receiver_address_complement: data?.receiver_address_complement
      }));

      setReceiverEdits({
        name: data?.receiver_name || '',
        phone: data?.receiver_phone || '',
        address: data?.receiver_address || '',
        city: data?.receiver_city || '',
        country: data?.receiver_country || '',
        commune: data?.receiver_commune || '',
        neighborhood: data?.receiver_neighborhood || '',
        address_complement: data?.receiver_address_complement || ''
      });

      setIsEditingReceiver(false);
      alert('✓ Destinataire mis à jour avec succès');
      
    } catch (err) {
      console.error('❌ Erreur sauvegarde destinataire:', err);
      alert(err?.message || 'Erreur lors de la mise à jour du destinataire');
    } finally {
      setActionLoading(false);
    }
  };

  const handleCancelReceiverEdit = () => {
    if (shipment) {
      setReceiverEdits({
        name: shipment?.receiver_name || '',
        phone: shipment?.receiver_phone || '',
        address: shipment?.receiver_address || '',
        city: shipment?.receiver_city || '',
        country: shipment?.receiver_country || '',
        commune: shipment?.receiver_commune || '',
        neighborhood: shipment?.receiver_neighborhood || '',
        address_complement: shipment?.receiver_address_complement || ''
      });
    }
    setIsEditingReceiver(false);
  };

  const handleStatusUpdate = async (newStatus) => {
    try {
      setActionLoading(true);
      await adminService?.updateShipmentStatus(shipmentId, newStatus);
      
      // Track status update
      trackShipmentEvent('status_updated', {
        id: shipmentId,
        reference: shipment?.reference,
        old_status: shipment?.status,
        new_status: newStatus
      });
      
      await loadShipmentDetails();
    } catch (err) {
      console.error('❌ Erreur mise à jour statut:', err);
      alert(err?.message || 'Erreur lors de la mise à jour du statut');
      trackError('shipment_status_update_error', err?.message, { shipment_id: shipmentId });
    } finally {
      setActionLoading(false);
    }
  };

  const handleSendMessage = async (message) => {
    try {
      console.log('📤 Handling send message:', message);
      
      // Send message via adminService
      await adminService?.sendMessage(shipmentId, message);
      
      // Reload messages to show the new one
      const updatedMessages = await adminService?.getShipmentMessages(shipmentId);
      setMessages(updatedMessages);
      
      console.log('✅ Message sent and messages reloaded');
    } catch (err) {
      console.error('❌ Erreur envoi message:', err);
      alert(err?.message || 'Erreur lors de l\'envoi du message');
    }
  };

  const handleSave = async () => {
    if (!shipmentId || !shipment) {
      alert('Aucun envoi à sauvegarder');
      return;
    }

    try {
      setActionLoading(true);
      console.log('💾 Sauvegarde modifications:', shipmentId);
      
      // ✅ Direct Supabase update with editable fields
      const { data, error } = await supabase?.from('shipments')?.update({
          // Sender fields
          sender_name: shipment?.sender?.name || shipment?.senderName,
          sender_phone: shipment?.sender?.phone || shipment?.senderPhone,
          sender_address: shipment?.sender?.address || shipment?.senderAddress,
          sender_city: shipment?.sender?.city || shipment?.senderCity,
          sender_country: shipment?.sender?.country || shipment?.senderCountry,
          
          // Receiver fields
          receiver_name: shipment?.receiver?.name || shipment?.receiverName,
          receiver_phone: shipment?.receiver?.phone || shipment?.receiverPhone,
          receiver_address: shipment?.receiver?.address || shipment?.receiverAddress,
          receiver_city: shipment?.receiver?.city || shipment?.receiverCity,
          receiver_country: shipment?.receiver?.country || shipment?.receiverCountry,
          
          // Shipment details
          description: shipment?.description,
          weight: shipment?.weight,
          dimensions: shipment?.dimensions,
          shipment_type: shipment?.shipmentType || shipment?.shipment_type,
          estimated_delivery_date: shipment?.estimatedDeliveryDate || shipment?.estimated_delivery_date,
          
          updated_at: new Date()?.toISOString()
        })?.eq('id', shipmentId)?.select()?.single();

      if (error) throw error;

      console.log('✅ Modifications enregistrées:', data);
      setHasChanges(false);
      alert('✓ Modifications enregistrées avec succès');
      
      // Reload to get fresh data
      await loadShipmentDetails();
      
    } catch (err) {
      console.error('❌ Erreur sauvegarde:', err);
      alert(err?.message || 'Erreur lors de la sauvegarde des modifications');
    } finally {
      setActionLoading(false);
    }
  };

  const handleCancel = () => {
    // ✅ Navigate back to admin shipments dashboard
    navigate('/admin-shipments-dashboard');
  };

  // ✅ NEW: Handler for payment update
  const handlePaymentUpdate = async () => {
    try {
      // Reload shipment data to reflect payment changes
      await loadShipmentDetails();
    } catch (err) {
      console.error('❌ Error updating payment:', err);
      alert(err?.message || 'Erreur lors de la mise à jour du paiement');
    }
  };

  // ✅ NEW: Handler for photo upload
  const handlePhotoUpload = async () => {
    try {
      // Reload shipment data to reflect photo changes
      await loadShipmentDetails();
    } catch (err) {
      console.error('❌ Error uploading photo:', err);
      alert(err?.message || 'Erreur lors du téléchargement de la photo');
    }
  };

  // ✅ NEW: Handler for document upload
  const handleDocumentUpload = async () => {
    try {
      // Reload shipment data to reflect document changes
      await loadShipmentDetails();
    } catch (err) {
      console.error('❌ Error uploading document:', err);
      alert(err?.message || 'Erreur lors du téléchargement du document');
    }
  };

  // ✅ NEW: Handler for invoice regeneration
  const handleRegenerateInvoice = async () => {
    try {
      setActionLoading(true);
      await invoiceService?.regenerateInvoice(shipmentId);
      alert('✓ Facture régénérée avec succès');
      // Refresh shipment files to show the new PDF
      await loadShipmentFiles(shipmentId);
    } catch (err) {
      console.error('❌ Erreur régénération facture:', err);
      alert(err?.message || 'Erreur lors de la régénération de la facture');
    } finally {
      setActionLoading(false);
    }
  };

  // Add useEffect to load container info if shipment has one
  useEffect(() => {
    // ✅ FIX: Use snake_case field name from database AND check if shipment exists
    if (shipment && shipment?.container_id) {
      loadContainerInfo();
    }
    if (shipment) {
      loadOpenContainers();
    }
  }, [shipment]);

  const loadContainerInfo = async () => {
    try {
      // ✅ FIX: Use snake_case field name from database
      const container = await containerService?.getById(shipment?.container_id);
      setCurrentContainer(container);
    } catch (err) {
      console.error('Error loading container:', err);
    }
  };

  const loadOpenContainers = async () => {
    try {
      const data = await containerService?.getOpenContainers();
      setContainers(data);
    } catch (err) {
      console.error('Error loading containers:', err);
    }
  };

  const handleUpdateContainer = async () => {
    try {
      setUpdating(true);
      if (selectedNewContainerId) {
        await containerService?.assignShipmentToContainer(shipmentId, selectedNewContainerId);
      } else {
        await containerService?.removeShipmentFromContainer(shipmentId);
      }
      await loadShipmentDetails();
      setShowContainerSelector(false);
      setError('');
    } catch (err) {
      setError(`Erreur: ${err?.message}`);
    } finally {
      setUpdating(false);
    }
  };

  const breadcrumbItems = [
    { label: 'Admin', path: '/admin' },
    { label: 'Envois', path: '/admin-shipments' },
    { label: shipment?.reference || 'Détails', path: '' }
  ];

  const handleAddItem = async (catalogItemId, quantity) => {
    setActionLoading(true);
    try {
      await adminService?.addShipmentItem(shipmentId, catalogItemId, quantity);
      await loadShipmentDetails(); // Reload to get updated data
    } catch (err) {
      console.error('Erreur ajout article:', err);
      alert(err?.message || 'Erreur lors de l\'ajout de l\'article');
    } finally {
      setActionLoading(false);
    }
  };

  const handleRemoveItem = async (itemId) => {
    setActionLoading(true);
    try {
      await adminService?.removeShipmentItem(itemId);
      await loadShipmentDetails();
    } catch (err) {
      console.error('Erreur suppression article:', err);
      alert(err?.message || 'Erreur lors de la suppression de l\'article');
    } finally {
      setActionLoading(false);
    }
  };

  // ✅ AFFICHAGE ÉTAT DE CHARGEMENT
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement des détails de l'envoi...</p>
        </div>
      </div>
    );
  }

  // ✅ AFFICHAGE ERREUR AVEC MESSAGE CLAIR
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md w-full">
          <div className="flex items-start">
            <svg className="w-6 h-6 text-red-600 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div className="flex-1">
              <h3 className="text-red-800 font-semibold mb-2">Aucun envoi trouvé pour cet identifiant</h3>
              <p className="text-red-700 text-sm mb-4">{error}</p>
              <div className="space-x-2">
                <button
                  onClick={loadShipmentDetails}
                  className="text-sm bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                  Réessayer
                </button>
                <button
                  onClick={() => navigate('/admin-shipments-dashboard')}
                  className="text-sm bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
                >
                  Retour à la liste des envois
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ✅ INDICATEUR DE CHARGEMENT POUR ACTIONS
  const LoadingOverlay = () => actionLoading ? (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 flex items-center space-x-3">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        <span className="text-gray-700">Traitement en cours...</span>
      </div>
    </div>
  ) : null;

  // ✅ NEW: Calculate totals dynamically from items array
  const calculateItemsTotal = () => {
    if (!shipment?.items || shipment?.items?.length === 0) return 0;
    return shipment?.items?.reduce((sum, item) => sum + parseFloat(item?.priceTotal || 0), 0);
  };

  const calculateFinalTotal = () => {
    const subtotal = calculateItemsTotal();
    const discount = parseFloat(shipment?.discount_amount || shipment?.discount || 0);
    return Math.max(subtotal - discount, 0);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminNavigation />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <header>
          <div className="bg-white border-b border-gray-200 shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <button
                    onClick={handleBack}
                    className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors mb-4"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h10M5 21h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="text-sm font-medium">Retour aux envois</span>
                  </button>
                  
                  <div className="flex items-center space-x-4 mb-3">
                    <h1 className="text-2xl font-bold text-gray-900">Gestion de l'envoi</h1>
                  </div>
                  
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <div className="flex items-baseline space-x-2">
                      <span className="text-sm text-gray-500">Référence:</span>
                      <span className="text-3xl font-bold text-blue-600">{shipment?.reference}</span>
                    </div>
                    
                    <div className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold ${
                      shipment?.current_status === 'en_transit' ? 'bg-blue-100 text-blue-800' :
                      shipment?.current_status === 'livré' ? 'bg-green-100 text-green-800' :
                      shipment?.current_status === 'en_attente'? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {shipment?.current_status}
                    </div>
                  </div>
                  
                  <div className="mt-3 flex items-center space-x-4 text-sm text-gray-600">
                    <div className="flex items-center space-x-2">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h12a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <span>Créé le: {shipment?.created_at ? new Date(shipment?.created_at)?.toLocaleDateString('fr-FR') : '-'}</span>
                    </div>
                    {shipment?.estimated_delivery_date && (
                      <div className="flex items-center space-x-2">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span>Livraison estimée: {new Date(shipment?.estimated_delivery_date)?.toLocaleDateString('fr-FR')}</span>
                      </div>
                    )}
                  </div>
                </div>
                
                <button
                  onClick={handleRegenerateInvoice}
                  disabled={actionLoading}
                  className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                  </svg>
                  <span>Regénérer la facture</span>
                </button>
              </div>
            </div>
          </div>
        </header>
        <div className="layout">
          <div className="left-column">
            {/* ✅ FIXED: Carte Expéditeur - Read-only with correct data access */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Expéditeur</h2>
                <span className="text-xs text-gray-500 italic">(lecture seule)</span>
              </div>
              <div className="space-y-3">
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Nom:</span>
                  <span className="text-sm font-medium text-gray-900">{shipment?.sender?.name || '-'}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Téléphone:</span>
                  <span className="text-sm font-medium text-gray-900">{shipment?.sender?.phone || '-'}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Adresse:</span>
                  <span className="text-sm font-medium text-gray-900 text-right">{shipment?.sender?.address || '-'}</span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm text-gray-600">Ville / Pays:</span>
                  <span className="text-sm font-medium text-gray-900">{shipment?.sender?.city || '-'} / {shipment?.sender?.country || '-'}</span>
                </div>
              </div>
            </div>

            {/* ✅ REPLACED: Use new RecipientFormSection component */}
            <RecipientFormSection
              recipientData={{
                name: isEditingReceiver ? receiverEdits?.name : (shipment?.receiver_name || ''),
                phone: isEditingReceiver ? receiverEdits?.phone : (shipment?.receiver_phone || ''),
                address: isEditingReceiver ? receiverEdits?.address : (shipment?.receiver_address || ''),
                city: isEditingReceiver ? receiverEdits?.city : (shipment?.receiver_city || ''),
                country: isEditingReceiver ? receiverEdits?.country : (shipment?.receiver_country || ''),
                commune: isEditingReceiver ? receiverEdits?.commune : (shipment?.receiver_commune || ''),
                neighborhood: isEditingReceiver ? receiverEdits?.neighborhood : (shipment?.receiver_neighborhood || ''),
                address_complement: isEditingReceiver ? receiverEdits?.address_complement : (shipment?.receiver_address_complement || '')
              }}
              onFieldChange={handleReceiverFieldChange}
              errors={errors}
              isEditing={isEditingReceiver}
              isLoading={actionLoading}
              onSave={handleSaveReceiverChanges}
              onCancel={handleCancelReceiverEdit}
              onEdit={() => setIsEditingReceiver(true)}
            />

            {/* Add Container Info Card - Insert after ContactInfoSection */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Conteneur Maritime</h2>
              </div>

              {currentContainer ? (
                <div className="space-y-3">
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Code Conteneur:</span>
                    <a
                      href={`/admin-container-detail/${currentContainer?.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm font-semibold text-teal-600 hover:text-teal-700 hover:underline"
                    >
                      {currentContainer?.containerCode}
                    </a>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Route:</span>
                    <span className="text-sm text-gray-900">
                      {currentContainer?.departurePort} → {currentContainer?.destinationPort}
                    </span>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-100">
                    <span className="text-sm text-gray-600">Statut:</span>
                    <span className={`text-sm px-2 py-1 rounded ${
                      currentContainer?.status === 'open' ? 'bg-green-100 text-green-700' :
                      currentContainer?.status === 'closed' ? 'bg-orange-100 text-orange-700' :
                      currentContainer?.status === 'departed' ? 'bg-blue-100 text-blue-700' :
                      currentContainer?.status === 'arrived'? 'bg-purple-100 text-purple-700' : 'bg-gray-100 text-gray-700'
                    }`}>
                      {currentContainer?.status}
                    </span>
                  </div>
                  {currentContainer?.departureDate && (
                    <div className="flex justify-between py-2 border-b border-gray-100">
                      <span className="text-sm text-gray-600">Date de départ:</span>
                      <span className="text-sm text-gray-900">
                        {new Date(currentContainer?.departureDate)?.toLocaleDateString('fr-FR')}
                      </span>
                    </div>
                  )}
                  {currentContainer?.etaDate && (
                    <div className="flex justify-between py-2">
                      <span className="text-sm text-gray-600">Arrivée estimée:</span>
                      <span className="text-sm text-gray-900">
                        {new Date(currentContainer?.etaDate)?.toLocaleDateString('fr-FR')}
                      </span>
                    </div>
                  )}
                  
                  {/* Modifier button */}
                  <div className="pt-3 border-t border-gray-200">
                    <button
                      onClick={() => setShowContainerSelector(!showContainerSelector)}
                      className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      <span>Modifier le conteneur</span>
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <p className="text-sm text-gray-500 mb-4">
                    Cet envoi n'est pas encore affecté à un conteneur
                  </p>
                  <button
                    onClick={() => setShowContainerSelector(!showContainerSelector)}
                    className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                    <span>Affecter à un conteneur</span>
                  </button>
                </div>
              )}

              {showContainerSelector && (
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sélectionner un conteneur
                  </label>
                  <select
                    value={selectedNewContainerId}
                    onChange={(e) => setSelectedNewContainerId(e?.target?.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent mb-3"
                  >
                    <option value="">— Aucun conteneur —</option>
                    {containers?.map((container) => (
                      <option key={container?.id} value={container?.id}>
                        {container?.departureDate
                          ? new Date(container?.departureDate)?.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })
                          : 'Date inconnue'
                        }
                        {' — '}
                        {container?.departurePort || '?'} → {container?.destinationPort || '?'}
                        {' — '}
                        {container?.containerCode}
                        {' — '}
                        {container?.statusLabel || container?.status}
                      </option>
                    ))}
                  </select>
                  <div className="flex gap-2">
                    <button
                      onClick={handleUpdateContainer}
                      disabled={updating}
                      className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:opacity-50"
                    >
                      {updating ? 'Mise à jour...' : 'Mettre à jour'}
                    </button>
                    <button
                      onClick={() => setShowContainerSelector(false)}
                      className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* ✅ NEW: Carte Photos de Collecte - Insert BEFORE "Détails de l'envoi" */}
            {shipment?.pickup_photo_urls && shipment?.pickup_photo_urls?.length > 0 && (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div>
                      <h2 className="text-lg font-semibold text-gray-900">Photos de Collecte</h2>
                      <span className="text-xs text-gray-500 italic">(copiées depuis la collecte)</span>
                    </div>
                  </div>
                  
                  {/* ✅ NEW: Download Evidence Button */}
                  {(pickupPhotosSignedUrls?.length > 0 || pickupTask?.clientSignatureUrl) && (
                    <div className="relative group">
                      <button
                        disabled={downloadingEvidence}
                        className="flex items-center space-x-2 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {downloadingEvidence ? (
                          <>
                            <svg className="animate-spin w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                            <span>Téléchargement...</span>
                          </>
                        ) : (
                          <>
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            <span>Télécharger les preuves</span>
                          </>
                        )}
                      </button>
                      
                      {/* ✅ NEW: Dropdown menu for download options */}
                      {!downloadingEvidence && (
                        <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 hidden group-hover:block z-10">
                          <div className="p-2">
                            <button
                              onClick={() => handleDownloadEvidence('separate')}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors"
                            >
                              <div className="flex items-start space-x-3">
                                <svg className="w-5 h-5 text-orange-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                <div>
                                  <p className="font-medium text-gray-900">Télécharger séparément</p>
                                  <p className="text-xs text-gray-500 mt-1">
                                    Signature + {pickupPhotosSignedUrls?.length} photo{pickupPhotosSignedUrls?.length > 1 ? 's' : ''}
                                  </p>
                                </div>
                              </div>
                            </button>
                            
                            <button
                              onClick={() => handleDownloadEvidence('zip')}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors mt-1"
                            >
                              <div className="flex items-start space-x-3">
                                <svg className="w-5 h-5 text-orange-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                                </svg>
                                <div>
                                  <p className="font-medium text-gray-900">Tout télécharger (ZIP)</p>
                                  <p className="text-xs text-gray-500 mt-1">
                                    Archive contenant tous les fichiers
                                  </p>
                                </div>
                              </div>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                
                {pickupPhotosLoading ? (
                  <div className="flex items-center justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-600"></div>
                    <span className="ml-3 text-gray-600">Chargement des photos...</span>
                  </div>
                ) : pickupPhotosError ? (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-center">
                    <p className="text-red-600 text-sm">{pickupPhotosError}</p>
                    <button
                      onClick={() => generatePickupPhotosSignedUrls(shipment?.pickup_photo_urls)}
                      className="mt-2 text-sm text-red-700 hover:text-red-800 underline"
                    >
                      Réessayer
                    </button>
                  </div>
                ) : pickupPhotosSignedUrls?.length > 0 ? (
                  <div className="grid grid-cols-2 gap-3">
                    {pickupPhotosSignedUrls?.map((url, index) => (
                      <div key={index} className="border rounded-lg overflow-hidden bg-gray-50">
                        <img
                          src={url}
                          alt={`Photo de collecte ${index + 1}`}
                          className="w-full h-48 object-cover hover:scale-105 transition-transform cursor-pointer"
                          onClick={() => window.open(url, '_blank')}
                          onError={(e) => {
                            console.error('❌ Failed to load pickup photo');
                            e.target.style.display = 'none';
                          }}
                        />
                        <div className="p-2 text-center">
                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-orange-600 hover:text-orange-700 underline"
                          >
                            Voir en plein écran
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500 text-sm">
                    Aucune photo de collecte disponible
                  </div>
                )}
                
                <div className="mt-3 pt-3 border-t border-gray-200">
                  <p className="text-xs text-gray-500">
                    📃 Ces photos proviennent de la collecte effectuée par le chauffeur
                  </p>
                </div>
              </div>
            )}

            {/* Carte Détails de l'envoi */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Détails de l'envoi</h2>
              </div>
              <div className="space-y-3">
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Description:</span>
                  <span className="text-sm font-medium text-gray-900 text-right max-w-xs">
                    {shipment?.items && shipment?.items?.length > 0 
                      ? shipment?.items?.map(item => 
                          `${item?.quantity} ${item?.itemName}`
                        )?.join(' + ')
                      : shipment?.description || '-'
                    }
                  </span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Départ estimé:</span>
                  <span className="text-sm font-medium text-gray-900">
                    {shipment?.estimated_departure_date ? new Date(shipment?.estimated_departure_date)?.toLocaleDateString('fr-FR') : '-'}
                  </span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Livraison estimée:</span>
                  <span className="text-sm font-medium text-gray-900">
                    {shipment?.estimated_delivery_date ? new Date(shipment?.estimated_delivery_date)?.toLocaleDateString('fr-FR') : '-'}
                  </span>
                </div>
                {shipment?.actual_delivery_date && (
                  <div className="flex justify-between py-2">
                    <span className="text-sm text-gray-600">Livraison réelle:</span>
                    <span className="text-sm font-medium text-green-600">
                      {new Date(shipment?.actual_delivery_date)?.toLocaleDateString('fr-FR')}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* Carte Messages & Notes */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Messages & notes</h2>
              </div>
              
              {/* Messages timeline */}
              <div className="space-y-4 mb-6 max-h-96 overflow-y-auto">
                {messages?.length > 0 ? (
                  messages?.map((msg) => (
                    <div key={msg?.id} className="flex space-x-3 pb-4 border-b border-gray-100 last:border-0">
                      <div className="flex-shrink-0">
                        <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                          <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between mb-1">
                          <p className="text-sm font-medium text-gray-900">{msg?.author || 'Admin'}</p>
                          <span className="text-xs text-gray-500">
                            {msg?.created_at ? new Date(msg?.created_at)?.toLocaleDateString('fr-FR') : ''}
                          </span>
                        </div>
                        <p className="text-sm text-gray-700">{msg?.content}</p>
                        {msg?.is_client_visible && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-1">
                            Visible client
                          </span>
                        )}
                        {!msg?.is_client_visible && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 mt-1">
                            Interne
                          </span>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-sm text-gray-500 text-center py-4">Aucun message</p>
                )}
              </div>

              {/* Message input form */}
              <MessagingSection
                messages={[]}
                onSendMessage={handleSendMessage}
              />
            </div>
          </div>

          <div className="right-column">
            {/* Carte Articles & Prix */}
            <ShipmentItemsSection
              shipmentId={shipmentId}
              items={shipment?.items || []}
              shipment={shipment}
              onUpdate={loadShipmentData}
            />

            {/* ✅ MODIFIED: Carte Total & Remise - Now calculates from items dynamically */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Récapitulatif</h2>
              </div>
              
              <div className="space-y-3">
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Total articles:</span>
                  <span className="text-sm font-medium text-gray-900">
                    {calculateItemsTotal()?.toFixed(2)} €
                  </span>
                </div>
                
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Remise:</span>
                  <span className="text-sm font-medium text-red-600">
                    -{(parseFloat(shipment?.discount_amount || shipment?.discount || 0))?.toFixed(2)} €
                  </span>
                </div>
                
                <div className="flex justify-between py-3 bg-blue-50 rounded-lg px-3 mt-2">
                  <span className="text-base font-semibold text-gray-900">Total à payer:</span>
                  <span className="text-2xl font-bold text-blue-600">
                    {calculateFinalTotal()?.toFixed(2)} €
                  </span>
                </div>
              </div>
            </div>

            {/* ✅ NEW: Payment Tracking Section - Insert after Total & Remise, before Loyalty */}
            <PaymentTrackingSection
              shipment={shipment}
              onUpdate={loadShipmentData}
              onPaymentUpdate={handlePaymentUpdate}
            />

            {/* Documents & Factures */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Documents & Factures</h2>
                {shipmentFiles?.length > 0 && (
                  <span className="ml-auto text-xs bg-red-100 text-red-700 px-2 py-1 rounded-full font-medium">
                    {shipmentFiles?.length} fichier{shipmentFiles?.length > 1 ? 's' : ''}
                  </span>
                )}
              </div>

              {shipmentFilesLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-red-600"></div>
                  <span className="ml-3 text-gray-500 text-sm">Chargement des documents...</span>
                </div>
              ) : shipmentFiles?.length === 0 ? (
                <div className="text-center py-8">
                  <svg className="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="text-sm text-gray-500">Aucun document disponible</p>
                  <p className="text-xs text-gray-400 mt-1">Les factures générées apparaîtront ici</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {shipmentFiles?.map((file) => (
                    <div key={file?.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-red-50 hover:border-red-200 transition-colors">
                      <div className="flex items-center space-x-3 min-w-0 flex-1">
                        {/* PDF Icon */}
                        <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                          <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 1.5L18.5 9H13V3.5zM6 20V4h5v7h7v9H6z"/>
                            <path d="M8 12h8v1H8zm0 2h8v1H8zm0 2h5v1H8z"/>
                          </svg>
                        </div>
                        {/* File info */}
                        <div className="min-w-0 flex-1">
                          <p className="text-sm font-medium text-gray-900 truncate">{file?.file_name}</p>
                          <div className="flex items-center space-x-2 mt-0.5">
                            <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                              file?.file_type === 'invoice' ? 'bg-blue-100 text-blue-700' :
                              file?.file_type === 'document'? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'
                            }`}>
                              {file?.file_type === 'invoice' ? 'Facture' : file?.file_type === 'document' ? 'Document' : file?.file_type || 'Fichier'}
                            </span>
                            <span className="text-xs text-gray-400">
                              {file?.created_at ? new Date(file?.created_at)?.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* Action buttons */}
                      <div className="flex items-center space-x-2 flex-shrink-0 ml-3">
                        <button
                          onClick={() => window.open(file?.file_url, '_blank')}
                          className="flex items-center space-x-1 px-3 py-1.5 text-xs bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                          title="Voir le document"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          <span>Voir</span>
                        </button>
                        <a
                          href={file?.file_url}
                          download={file?.file_name}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center space-x-1 px-3 py-1.5 text-xs bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                          title="Télécharger le document"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                          </svg>
                          <span>Télécharger</span>
                        </a>
                        <button
                          onClick={() => openEditFileModal(file)}
                          className="flex items-center space-x-1 px-3 py-1.5 text-xs bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors"
                          title="Modifier le nom du document"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                          <span>Modifier</span>
                        </button>
                        <button
                          onClick={() => handleDeleteShipmentFile(file)}
                          className="flex items-center space-x-1 px-3 py-1.5 text-xs bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                          title="Supprimer le document"
                        >
                          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                          <span>Supprimer</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Edit File Name Modal */}
            {editingFile && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6">
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center space-x-3">
                      <div className="w-9 h-9 bg-yellow-100 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">Modifier le document</h3>
                    </div>
                    <button
                      onClick={closeEditFileModal}
                      className="text-gray-400 hover:text-gray-600 transition-colors"
                      disabled={editFileSaving}
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="mb-5">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Nom du document</label>
                    <input
                      type="text"
                      value={editFileName}
                      onChange={(e) => setEditFileName(e?.target?.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yellow-500"
                      placeholder="Nom du fichier"
                      disabled={editFileSaving}
                    />
                  </div>
                  <div className="flex space-x-3">
                    <button
                      onClick={closeEditFileModal}
                      disabled={editFileSaving}
                      className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      Annuler
                    </button>
                    <button
                      onClick={handleEditShipmentFileSave}
                      disabled={editFileSaving}
                      className="flex-1 px-4 py-2 text-sm font-medium text-white bg-yellow-500 rounded-lg hover:bg-yellow-600 transition-colors flex items-center justify-center space-x-2"
                    >
                      {editFileSaving ? (
                        <>
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                          <span>Enregistrement...</span>
                        </>
                      ) : (
                        <span>Enregistrer</span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Carte Fidélité client */}
            <LoyaltyManagementSection
              shipment={shipment}
              clientLoyaltyPoints={shipment?.clientLoyaltyPoints || 0}
              onUpdate={loadShipmentData}
            />

            {/* Carte Photos & Documents */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-gray-900">Photos & Documents</h2>
              </div>

              {/* Photos section */}
              <div className="mb-6">
                <h3 className="text-sm font-medium text-gray-700 mb-3">Photos du colis</h3>
                <PackagePhotoSection shipment={shipment} files={shipment?.pickup_photo_urls || []} />
                <PhotoUploadSection 
                  shipmentId={shipment?.id}
                  currentPhotoUrl={shipment?.photo_url}
                  onPhotoUploaded={loadShipmentData}
                  onPhotoUpload={handlePhotoUpload}
                />
              </div>

              {/* Documents section */}
              <div>
                <h3 className="text-sm font-medium text-gray-700 mb-3">Documents</h3>
                {shipment?.document_url && (
                  <div className="mb-2">
                    <a
                      href={shipment?.document_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-700"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m0 0l-3-3m3 3l3-3m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span>Document principal</span>
                    </a>
                  </div>
                )}
                {shipment?.extra_documents_urls?.length > 0 && (
                  <div className="space-y-1">
                    {shipment?.extra_documents_urls?.map((docUrl, index) => (
                      <a
                        key={index}
                        href={docUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-700 block"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <span>Document supplémentaire {index + 1}</span>
                      </a>
                    ))}
                  </div>
                )}
                <DocumentUploadSection 
                  shipmentId={shipment?.id}
                  documentUrl={shipment?.document_url}
                  onDocumentUploaded={loadShipmentData}
                  onDocumentUpload={handleDocumentUpload}
                />
              </div>
            </div>

            {/* Status Management Panel */}
            <StatusManagementPanel
              currentStatus={shipment?.current_status}
              onStatusUpdate={handleStatusUpdate}
            />
          </div>
        </div>
      </div>
      <ActionButtons
        onSave={handleSave}
        onCancel={handleCancel}
        hasChanges={hasChanges}
      />
    </div>
  );
}